var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.loaded),expression:"loaded"}],class:[_vm.classes, _vm.opacityClass],attrs:{"src":_vm.model},on:{"load":_vm.onLoaded}})])}
var staticRenderFns = []

export { render, staticRenderFns }